import { NavigateBefore, NavigateNext } from '@mui/icons-material';
import { RESPONSIVE_LARGE_WIDTH } from '../constants/sizes';
import useWindowDimensions from './windowHelper';


export default function CurrentIndexDotIndicator({ currentIndex, maxIndex, onNextClick, onPrevClick, }) {
    const { _, width } = useWindowDimensions();

    return (
        // Show dots for each index, highlight the current index.
        // Animate the dots when currentIndex changes.
        // Only show last dot as highlighted if currentIndex is at maxIndex.
        // Only show first dot as highlighted if currentIndex is at 0.
        <div style={{ padding: '0px 0px' }}>
            <div style={{ position: 'relative', maxWidth: '160px', margin: '0px auto' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50px',}}>
                    {Array.from({ length: maxIndex + 1 }).map((_, index) => {
                        let isVisible = false;
                        if (maxIndex <= 4) {
                            isVisible = true;
                        } else {
                            if (currentIndex <= 1) {
                                isVisible = index <= 4;
                            } else if (currentIndex >= maxIndex - 2) {
                                isVisible = index >= maxIndex - 4;
                            } else {
                                isVisible = Math.abs(index - currentIndex) <= 2;
                            }
                        }

                        if (!isVisible) {
                            return null;
                        }

                        const isActive = index === currentIndex;
                        const isMediumSize = Math.abs(index - currentIndex) === 1;
                        const dotSize = isActive ? 9 : isMediumSize ? 6 : 4;

                        return (
                            <div
                                key={index}
                                style={{
                                    width: dotSize,
                                    height: dotSize,
                                    borderRadius: '50%',
                                    backgroundColor: isActive ? 'var(--app-text)' : 'rgba(var(--app-ink-rgb), 0.3)',
                                    margin: '0 4px',
                                    transition: 'background-color 0.3s, width 0.3s, height 0.3s',
                                }}
                            />
                        );
                    })}

                    <div style={{ position: 'absolute', top: '50%', left: '0px', transform: 'translateY(-50%)' }}>
                        <button onClick={onPrevClick} className={'nextPrevButtons'} style={{ opacity: currentIndex === 0 ? 0 : 1 }}>
                            <NavigateBefore style={{ color: 'rgba(var(--app-ink-rgb), 0.3)', fontSize: '26px', verticalAlign: 'middle'}} />
                        </button>
                    </div>
                                            <div style={{ position: 'absolute', top: '50%', right: '0px', transform: 'translateY(-50%)' }}>
                        <button onClick={onNextClick} className={'nextPrevButtons'} style={{ opacity: currentIndex === maxIndex ? 0 : 1 }}>
                            <NavigateNext style={{ color: 'rgba(var(--app-ink-rgb), 0.3)', fontSize: '26px', verticalAlign: 'middle' }} />
                        </button>
                    </div>
                    {/* {width >= RESPONSIVE_LARGE_WIDTH ?

                        :
                        <></>}
                    {width >= RESPONSIVE_LARGE_WIDTH ?

                        :
                        <></>} */}
                </div>
            </div>
        </div>
    );
}
